// G5-D3 (PR278): Radix's document-level Escape dismissal is environment-
// divergent, so OUR popovers own Escape at their content. The handler closes
// ONLY the layer the key was pressed in: an Escape originating in a NESTED
// floating layer (its portal bubbles through the React tree into the parent
// content's handler) belongs to that nested layer, never to this one — the
// PR278-8402 regression closed both on one press.
import type { KeyboardEvent } from 'react'

export const escapeClosesOwnLayer = (close: () => void) => (e: KeyboardEvent) => {
  if (e.key !== 'Escape') return
  const targetLayer = (e.target as HTMLElement).closest('[data-radix-popper-content-wrapper]')
  const ownLayer = (e.currentTarget as HTMLElement).closest('[data-radix-popper-content-wrapper]')
  if (targetLayer !== ownLayer) return // a nested layer owns this press
  e.preventDefault()
  e.stopPropagation()
  close()
}
